import { createRoute } from '@tanstack/react-router'
import { onboardingRoute } from '../_onboarding'
import { OnboardingQuiz } from '@/pages/onboarding/OnboardingQuiz'
import { OnboardingProfileSetup } from '@/pages/onboarding/OnboardingProfileSetup'
import { OnboardingPermissions } from '@/pages/onboarding/OnboardingPermissions'
import { OnboardingFindFriends } from '@/pages/onboarding/OnboardingFindFriends'

/**
 * /onboarding/permissions - Request location and notification permissions
 */
export const onboardingPermissionsRoute = createRoute({
  getParentRoute: () => onboardingRoute,
  path: '/onboarding/permissions',
  component: OnboardingPermissions,
})

/**
 * /onboarding/profile - Profile setup (photo, bio)
 */
export const onboardingProfileRoute = createRoute({
  getParentRoute: () => onboardingRoute,
  path: '/onboarding/profile',
  component: OnboardingProfileSetup,
})

/**
 * /onboarding/friends - Find and follow friends
 */
export const onboardingFriendsRoute = createRoute({
  getParentRoute: () => onboardingRoute,
  path: '/onboarding/friends',
  component: OnboardingFindFriends,
})

/**
 * /onboarding/quiz - Welcome screen before Quiz 1
 */
export const onboardingQuizRoute = createRoute({
  getParentRoute: () => onboardingRoute,
  path: '/onboarding/quiz',
  component: OnboardingQuiz,
})
